<div class="app-wrapper" [ngClass]="{'with-overlay': view == VIEW_FEEDBACK_DONE || view == VIEW_FEEDBACK_ERROR || view == VIEW_FEEDBACK_WARNING || view == VIEW_UPLOAD_VERSION_WARNING}">
    <core-layout-modal-feedback class="modal-feedback" *ngIf="view == VIEW_FEEDBACK_DONE"
        [type]="'done'"
        [message]="'Request sent'"
        [text]="'Your request feedback has been successfully sent'"
        [buttonText]="'Done'"
        (action)="onSent($event)">
    </core-layout-modal-feedback>
    <core-layout-modal-feedback class="modal-feedback" *ngIf="view == VIEW_FEEDBACK_WARNING"
        [type]="'warning'"
        [message]="'Repeated request'"
        [text]="'You are trying to send an approval request to: '+ warningText +'. <br/>You have already requested approval for those versions, therefore we will NOT send one again for that version. All other approval request will be sent.<br/>Do you wish to continue?'"
        [buttonText]="'Continue'"
        [disabled]="modalButtonDisabled"
        (action)="onSubmit()"
        [secondButtonText]="'Cancel'"
        (secondButtonAction)="closeModal()">
    </core-layout-modal-feedback>
    <core-layout-modal-feedback class="modal-feedback m_over" *ngIf="view == VIEW_UPLOAD_VERSION_WARNING"
        [type]="'warning'"
        [message]="'Repeated request'"
        [text]="'You are trying to send a version request to '+ warningText +'. <br/>You have already requested a version for those versions, therefore we will NOT send one again for that version. All other request will be sent.<br/>Do you wish to continue?'"
        [buttonText]="'Continue'"
        [disabled]="modalButtonDisabled"
        (action)="onSubmit()"
        [secondButtonText]="'Cancel'"
        (secondButtonAction)="closeModal()">
    </core-layout-modal-feedback>
    <core-layout-modal-feedback class="modal-feedback" *ngIf="view == VIEW_FEEDBACK_ERROR"
        [type]="'fail'"
        [message]="'Error'"
        [text]="'Something went wrong. Please try again. If the error persists, please reach out to our support team through the Help Me button.'"
        [buttonText]="'Reload'"
        (action)="onError($event)">
    </core-layout-modal-feedback>

    <core-layout-error-not-found [hidden]="status != NOT_FOUND"></core-layout-error-not-found>
    
    <div class="loader plugin-section" [hidden]="status != LOADING">
        <div class="dimmed_outset">
            <core-title-section [title]="'PROJECT <small>(# . . .)</small>'"></core-title-section>
        </div>
        <div class="dimmed dimmed_main">
            <div class="dimmed_content">
                <div class="dimmed_flex">
                    <span class="dimmed_tag"></span>
                    <span class="dimmed_tag"></span>
                    <span class="dimmed_tag"></span>
                </div>
            </div>
        </div>
    </div>

    
    <nav class="tab_navigation">
        <core-helpers-navigation-vertical-tabs [hidden]="projectHeader != null || status == NOT_ALLOWED" [menu]="menuProjects"></core-helpers-navigation-vertical-tabs>
    </nav>

    <section *ngIf="status == DONE && permission && view != VIEW_DONE" class="main-content">
        <div class="app-main">
            <div class="request-main">
                <project-details-breadcrumb-header *ngIf="request != null"
                    [project]="request"
                    [title]="breadcrumbText"
                    [breadcrumbs]="breadcrumbs"
                ></project-details-breadcrumb-header>

                <div class="sub-header">
                    <div>
                        <h3>{{headerText}}</h3>
                    </div>
                    <div class="fieldset-buttons">
                        <core-helpers-forms-button
                        [type]="'grey'"
                        [text]="'Cancel'"
                        (submit)="cancel()"
                        [hidden]="view != VIEW_SELECTOR || !isSelectionReady()"
                        ></core-helpers-forms-button>
                        <core-helpers-forms-button
                        [type]="'grey'"
                        [text]="'Previous'"
                        (submit)="setView(VIEW_SELECTOR)"
                        [hidden]="view != VIEW_SENDER"
                        ></core-helpers-forms-button>
                        <core-helpers-forms-button-white
                        [text]="'Next'"
                        (submit)="setView(VIEW_SENDER)"
                        [hidden]="view != VIEW_SELECTOR || !isSelectionReady()"
                        ></core-helpers-forms-button-white>
                        <core-helpers-forms-button-white
                        [disabled]="submitted"
                        [text]="'Send'"
                        (submit)="onPreSubmit()"
                        [hidden]="view != VIEW_SENDER || !isRequestFeedbackReady()"
                        ></core-helpers-forms-button-white>
                    </div>
                </div>
                <div class="main-feedback-content">
                  <share-feedback-select-files-section
                    [hidden]="view != VIEW_SELECTOR"
                    [request]="request"
                    [files]="filesSelected"
                    (selectedChange)="onChange($event);"
                  >
                  </share-feedback-select-files-section>
                  <div class="share-send-box" [hidden]="(view != VIEW_SENDER &&  view != VIEW_FEEDBACK_DONE && view != VIEW_FEEDBACK_WARNING && view != VIEW_UPLOAD_VERSION_WARNING)">
                    <h4 class="h4_label">CHOOSE THE TYPE OF FEEDBACK</h4>
                        <form [formGroup]="form" action="" >
                            <div class="feedback-options-form">
                                <div class="feedback-options-radio">
                                    <core-helpers-forms-input-radio
                                        [name]="'feedback_type'"
                                        [radioItems]="feedbackTypeOptions"
                                        [form]="form"
                                        (selectedChange)="onFeedbackOptionsChange($event)"
                                    ></core-helpers-forms-input-radio>
                                </div>
                        
                                <ng-container [ngSwitch]="this.form.get('feedback_type').value">
                                    <ng-template [ngSwitchCase]="this.FEEDBACK_TYPE_APPROVAL">
                                        <div class="lines lines-approval"></div>
                                        <div class="feedback-options-approval">
                                            <core-helpers-forms-input-checkbox
                                                [label]="'Request Digital Signature'"
                                                [name]="'signature'"
                                                [defaultChecked]="true"
                                                [form]="form"
                                                (checkedChange)="onSignatureChange($event)"
                                            ></core-helpers-forms-input-checkbox>
                                        </div>
                                    </ng-template>
                                    <ng-template [ngSwitchCase]="this.FEEDBACK_TYPE_COMMENTS">
                                        <div class="lines lines-comments"></div>
                                        <div  class="feedback-options-comments">
                                            <core-helpers-forms-input-checkbox
                                                [label]="'See everyone`s comments'"
                                                [name]="'allowness'"
                                                [defaultChecked]="true"
                                                [form]="form"
                                                (checkedChange)="onAllowChange($event)"
                                            ></core-helpers-forms-input-checkbox>
                                        </div>
                                    </ng-template>
                                    <ng-template [ngSwitchCase]="this.FEEDBACK_TYPE_ARTWORK">
                                        <div class="lines lines-status"></div>
                                        <div class="feedback-options-artwork">
                                            <div class="artwork-status">
                                                <core-helpers-forms-select
                                                    [optionSelected]="selectedStatus"
                                                    [options]="availableSelectStatus"
                                                    (select)="onStatusSelect($event)"
                                                ></core-helpers-forms-select>
                                            </div>
                                            <div class="box-default">
                                                <div class="artwork-automated-version">
                                                    <core-helpers-forms-input-checkbox
                                                        [label]="'Automated +1 subversion'"
                                                        [name]="'automated'"
                                                        [defaultChecked]="true"
                                                        [form]="form"
                                                        (checkedChange)="onAutomatedChange($event)"
                                                    ></core-helpers-forms-input-checkbox>
                                                </div>
                                                
                                                <ng-container *ngIf="displayVersioning">
                                                    <core-versions-add-number
                                                        [addVersion]="addVersionData"
                                                        (formReady)="addChildForm('versioning', $event)"
                                                        (addVersionChange)="onAddVersionChange($event)"
                                                    ></core-versions-add-number>
                                                </ng-container>
                                            </div>

                                                <!-- <div>
                                                    <input type="number" formControlName="version" (change)="onVersionChange()"/><span>.</span>
                                                    <input type="number" formControlName="subversion" (change)="onSubVersionChange()"/>
                                                  </div> -->
                                        </div>

                                    </ng-template>
                                </ng-container>
                            </div>
                        
                            <app-share-send-box
                                [subjectPlaceholder]="subject"
                                [form]="form"
                                [files]="filesSelected"
                                [defaultMessage]="messageDefaultPlaceholder"
                                [maxEmails]="getMaxEmails()"
                                (emailsChanged)="onEmailsChanged($event)"
                            ></app-share-send-box>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section *ngIf="status == DONE && permission && view == VIEW_DONE" class="main-content">
        <div class="app-main">
            <core-helper-box-done-close-tab
                [type]="'done'"
                [message]="'Done!'"
                [text]="'Your work here is done, feel free to close the tab now.'"
            >
            </core-helper-box-done-close-tab>
        </div>
    </section>
</div>
